export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7085.f137f037.jpg";